import { Box } from '@mui/material';

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}

export function a11yProps(index: number) {
    return {
        id: `result-tab-${index}`,
        'aria-controls': `result-tabpanel-${index}`,
    };
}

export function ResultTabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return value === index ? (
        <div style={{ display: 'flex', flex: 1 }} role='tabpanel' hidden={value !== index} id={`result-tabpanel-${index}`} aria-labelledby={`result-tab-${index}`} {...other}>
            <Box sx={{ width: '100%' }}>{children}</Box>
        </div>
    ) : null;
}
